import { render, staticRenderFns } from "./UserTargeting.vue?vue&type=template&id=5a07b5df&"
import script from "./UserTargeting.vue?vue&type=script&lang=js&"
export * from "./UserTargeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports